import { useNavigate } from 'react-router';
import { ForgotPasswordModal } from './ForgotPasswordModal';

export const ForgotPassword = () => {
  const navigate = useNavigate();

  return (
    <ForgotPasswordModal
      show={true}
      setShow={() => {
        navigate('/login');
      }}
    ></ForgotPasswordModal>
  );
};
